import * as SDK from "azure-devops-extension-sdk";
// ponytail: plain fetch against the documented REST surface instead of the
// generated azure-devops-extension-api clients. One less dependency, and the
// request/response shapes are stable + inspectable in the network tab.
const API = "api-version=7.1";
const ZERO_SHA = "0".repeat(40);
function orgUrl() {
    // Cloud only. On-prem (TFS) needs the collection URL from LocationService.
    return `https://dev.azure.com/${SDK.getHost().name}`;
}
async function call(path, init) {
    const token = await SDK.getAccessToken();
    const res = await fetch(`${orgUrl()}${path}`, {
        ...init,
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            ...init?.headers,
        },
    });
    if (!res.ok)
        throw new Error(`${res.status} ${res.statusText}: ${await res.text()}`);
    return res.json();
}
export async function listRepos() {
    const r = await call(`/_apis/git/repositories?${API}`);
    return r.value.sort((a, b) => a.name.localeCompare(b.name));
}
export async function listBranches(repoId) {
    const r = await call(`/_apis/git/repositories/${repoId}/refs?filter=heads&${API}`);
    return r.value;
}
/**
 * Creates refs/heads/<name> at <sourceSha>.
 *
 * updateRefs returns HTTP 200 even when the update is rejected — the verdict is
 * per-entry in value[].success. Do not treat a 2xx as created.
 */
export async function createBranch(repoId, name, sourceSha) {
    const r = await call(`/_apis/git/repositories/${repoId}/refs?${API}`, {
        method: "POST",
        body: JSON.stringify([
            { name: `refs/heads/${name}`, oldObjectId: ZERO_SHA, newObjectId: sourceSha },
        ]),
    });
    const result = r.value?.[0];
    if (!result?.success) {
        throw new Error(result?.updateStatus ?? "Branch creation rejected");
    }
}
/**
 * The artifact link ADO's built-in "create a branch" adds — what makes the
 * branch show under the work item's Development section. Artifact id is
 * project/repo/GB<name> with %2F separators (and each part itself encoded).
 * Requires the vso.work_write scope.
 */
export async function linkBranchToWorkItem(id, repo, name) {
    const artifact = `vstfs:///Git/Ref/${[repo.project.id, repo.id, `GB${name}`]
        .map(encodeURIComponent)
        .join("%2F")}`;
    await call(`/_apis/wit/workitems/${id}?${API}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json-patch+json" },
        body: JSON.stringify([
            {
                op: "add",
                path: "/relations/-",
                value: { rel: "ArtifactLink", url: artifact, attributes: { name: "Branch" } },
            },
        ]),
    });
}
export async function getWorkItemTitle(id) {
    const wi = await call(`/_apis/wit/workitems/${id}?fields=System.Title&${API}`);
    return wi.fields?.["System.Title"] ?? "";
}
export function branchUrl(repo, name) {
    return `${orgUrl()}/${encodeURIComponent(repo.project.name)}/_git/${encodeURIComponent(repo.name)}?version=GB${encodeURIComponent(name)}`;
}
